export enum EUserStatus {
  // Ищу квартиру
  Seeker = 'search',
  // Оформляю сделку
  Execute = 'inProgress',
  // Купил квартиру в этом ЖК
  Owning = 'living',
}
